import type { Image as StorefrontImage } from '@shopify/hydrogen/storefront-api-types';

export const DEFAULT_PRODUCT_IMAGE: Partial<StorefrontImage> = {
  url: 'https://cdn.shopify.com/s/images/themes/product-1.png',
  altText: 'product',
};

export const DEFAULT_OPEN_FILTERS = ['filter.p.vendor'];

export const DEFAULT_PRODUCT_PREVIEW_LENGTH = 5;

export const PRODUCT_QTY_MIN_DEFAULT = 1;
export const PRODUCT_QTY_MAX_DEFAULT = Infinity;

export const PRODUCT_DETAILS_QUERY_KEY = 'productDetails';
